function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.097,
    height: 35.835,
    viewBox: "0 0 48.097 35.835",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 33",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(17.391 8.13)",
    style: {
      fill: "#f6b119"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5194",
    d: "M15.458 27.5c-.479-6.706 4.121-11.687 10.048-12.125V4.782A4.788 4.788 0 0 0 20.724 0h-28.2a4.788 4.788 0 0 0-4.782 4.782V27.1a4.788 4.788 0 0 0 4.782 4.782h23.988a15.636 15.636 0 0 1-1.054-4.382zm-17.821-9.579c-2.3 2.2-5.243 4.423-6.3 5.475l-.41-18.614a1.6 1.6 0 0 1 1.594-1.594h28.2a1.6 1.6 0 0 1 1.594 1.594v9.053l-.761-.424c-1.09-1.09-3.316-.666-4.4.424l-7.589 7.588-6.806-3.788s-2.823-1.917-5.122.286z",
    transform: "translate(12.261)",
    style: {
      fill: "#f6b119"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5195",
    d: "M20.135 11a9.135 9.135 0 1 0 9.135 9.135A9.146 9.146 0 0 0 20.135 11zM24 21.54h-2.46V24a1.405 1.405 0 1 1-2.811 0v-2.46H16.27a1.405 1.405 0 1 1 0-2.811h2.46V16.27a1.405 1.405 0 1 1 2.811 0v2.46H24a1.405 1.405 0 1 1 0 2.811z",
    transform: "translate(18.827 6.565)",
    style: {
      fill: "#f6b119"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/add-image.836bfaad7c07f6766708769165b986af.svg";
export { ForwardRef as ReactComponent };